import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { memo } from 'react';
import { usePresenzeModo } from '../../hooks/usePresenzeModo';
import type {
  CalendarioConPresenze,
  PresenzeModo,
} from '../../utility_objects/preferenzeCalendario';
import { RigaVisualizzazione } from '../Visualizzazione/RigaVisualizzazione';

const SPIEGAZIONE_MESE = 'Le presenze non si vedono nella vista Mese.';

interface PresenzeToggleProps {
  /** Calendario con la fascia di cui si sceglie: ognuno ha la sua scelta. */
  calendario: CalendarioConPresenze;
  /** Vista Mese: la fascia non c'è, il selettore resta visibile ma disabilitato. */
  mese: boolean;
}

/**
 * Riga «Presenze» del riquadro Visualizzazione: «Nessuno» (niente fascia),
 * «Presenze» (una chip per persona col solo nome) o «Totali» (chip col testo
 * completo). Come il gruppo delle viste c'è sempre una voce selezionata: il
 * clic su quella già scelta non fa nulla. Solo nei calendari con la fascia
 * (agenda negozio, giornaliero Studio), che senza punto vendita non la
 * mostrano. Scelta del calendario (usePresenzeModo): cambiarla nell'agenda
 * negozio non tocca il giornaliero Studio, e il contrario.
 */
export const PresenzeToggle = memo(function PresenzeToggle({
  calendario,
  mese,
}: PresenzeToggleProps): JSX.Element {
  const { modo, imposta } = usePresenzeModo(calendario);

  return (
    <RigaVisualizzazione
      etichetta="Presenze"
      spiegazione={mese ? SPIEGAZIONE_MESE : undefined}
    >
      {(aria) => (
        <ToggleButtonGroup
          exclusive
          fullWidth
          value={modo}
          // null = clic sulla voce già selezionata: resta quella.
          onChange={(_, valore: PresenzeModo | null) => {
            if (!valore) return;
            imposta(valore);
          }}
          {...aria}
          data-testid="calendar-presenze-toggle"
        >
          <ToggleButton
            size="small"
            value="nessuna"
            disabled={mese}
            data-testid="calendar-presenze-modo-nessuna"
          >
            Nessuno
          </ToggleButton>
          <ToggleButton
            size="small"
            value="presenze"
            disabled={mese}
            data-testid="calendar-presenze-modo-presenze"
          >
            Presenze
          </ToggleButton>
          <ToggleButton
            size="small"
            value="totali"
            disabled={mese}
            data-testid="calendar-presenze-modo-totali"
          >
            Totali
          </ToggleButton>
        </ToggleButtonGroup>
      )}
    </RigaVisualizzazione>
  );
});
